import { WORNING_BLUE, WORNING_YELLOW } from 'constants/style';
import { ISDStatus } from 'modules/smartDevice';
import styled from 'styled-components';

interface StyledInfoBoxProps {
  markerStatus: ISDStatus;
  isBlue?: boolean;
}

export const StyledInfoBox = styled.div<StyledInfoBoxProps>`
  display: flex;
  flex-direction: column;
  gap: 12px;
  background-color: #212121e5;
  margin: 4px;
  padding: 16px;
  border: 0.5px solid
    ${({ markerStatus, isBlue }) =>
      isBlue
        ? WORNING_BLUE
        : markerStatus === 'UNKNOWN'
          ? '#E0E0E080'
          : markerStatus === 'NORMAL'
            ? '#6CCE8ECC'
            : markerStatus === 'WARNING'
              ? WORNING_YELLOW
              : '#FF0000CC'};
  box-shadow: 0px 0px 15.5px 0px
    ${({ markerStatus, isBlue }) =>
      isBlue
        ? WORNING_BLUE
        : markerStatus === 'UNKNOWN'
          ? '#E0E0E080'
          : markerStatus === 'NORMAL'
            ? '#6CCE8ECC'
            : markerStatus === 'WARNING'
              ? WORNING_YELLOW
              : '#FF0000CC'};

  .image-box {
    width: 62px;
    height: 62px;
    border-radius: 50%;
    background-color: #eeeeee;
  }

  .user-box {
    display: flex;
    flex-direction: column;
    gap: 2px;

    > h2 {
      color: var(--color-white);
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }

    > p {
      color: var(--color-white);
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }

  .device-box {
    display: flex;
    gap: 8px;
  }

  .sensors {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;
  }
`;
